module.exports = __webpack_public_path__ + "static/img/Noer Fajrin-full.afce993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Noer Fajrin-full.png
// module id = O64p
// module chunks = 1